import { M2faComponentBase } from "./M2faComponentBase";

export class Authenticator2FAComponent extends M2faComponentBase {
  text = "Enter the verification code generated by your authenticator app:";
}
